// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAYkcQxienQz36fi54OufZrXOcuM4VdmgQ", // This is public, safe to expose for client-side analytics
    authDomain: "east-cape-slips-map.firebaseapp.com",
    projectId: "east-cape-slips-map",
    storageBucket: "east-cape-slips-map.firebasestorage.app",
    messagingSenderId: "45088884869",
    appId: "1:45088884869:web:3a35c235b4f692e06e41ec",
    measurementId: "G-ZDRCDWLCNX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

console.log("📊 Firebase Analytics Initialized", {
    appId: firebaseConfig.appId,
    measurementId: firebaseConfig.measurementId
});

// Configure Analytics to accept cookies on any domain (fixes rejected cookie error)
// analytics.app.options.measurementId = firebaseConfig.measurementId; // Not needed if initialized correctly

if (typeof window !== 'undefined') {
    // @ts-ignore
    window['ga-disable-' + firebaseConfig.measurementId] = false;

    // @ts-ignore
    window.dataLayer = window.dataLayer || [];

    // @ts-ignore
    function gtag(...args: any[]) { window.dataLayer.push(args); }

    gtag('config', firebaseConfig.measurementId, {
        cookie_domain: 'auto',
        cookie_flags: 'SameSite=None; Secure'
    });
}

export { analytics };
